export type GenreExemplar = {
  id: string;
  work: { zh: string; en: string };
  sourceUrl: string;
  mechanism: { zh: string; en: string };
  transform: { zh: string; en: string };
};

export const GENRE_EXEMPLARS: Record<string, GenreExemplar> = {
  urban_emotion: {
    id: 'normal_people',
    work: { zh: '《普通人》', en: 'Normal People' },
    sourceUrl: 'https://www.bbc.co.uk/programmes/p089g8vv/episodes/guide',
    mechanism: {
      zh: '亲密关系在私下与公开场合呈现不同权力位置，误解随身份环境变化而累积。',
      en: 'Intimacy shifts between private and public settings as status changes create misreadings.',
    },
    transform: {
      zh: '改为原创城市、职业、家庭与事件；让阶层压力改变角色的具体选择，不复刻校园关系和原作桥段。',
      en: 'Invent a new city, occupations, families and events; let class pressure alter concrete choices without copying the original relationship or scenes.',
    },
  },
  suspense_reversal: {
    id: 'gone_girl',
    work: { zh: '《消失的爱人》', en: 'Gone Girl' },
    sourceUrl: 'https://www.20thcenturystudios.com/movies/gone-girl',
    mechanism: {
      zh: '亲密关系中的秘密与外部舆论共同塑造观众判断，后来的证据重新解释先前行动。',
      en: 'Private secrets and public perception shape the audience judgment until later evidence reframes earlier actions.',
    },
    transform: {
      zh: '换成原创的非失踪事件、人物目标和证据链；每次反转必须有前置可核查线索。',
      en: 'Use an original non-disappearance event, motives and evidence chain; every reversal needs a visible earlier clue.',
    },
  },
  family_power: {
    id: 'succession',
    work: { zh: '《继承之战》', en: 'Succession' },
    sourceUrl: 'https://www.hbo.com/succession',
    mechanism: {
      zh: '资源控制权让亲属关系与竞争关系重叠，父辈决定会改变子辈的联盟。',
      en: 'Control over a shared asset turns relatives into rivals and changes alliances after parental decisions.',
    },
    transform: {
      zh: '改写亲属结构与被争夺的资源，避开传媒集团和原作人物；让每次让步都有情感与现实代价。',
      en: 'Change the family structure and contested asset, avoiding the media empire and original characters; make every concession carry emotional and practical costs.',
    },
  },
  workplace_game: {
    id: 'devil_wears_prada',
    work: { zh: '《穿普拉达的女王》', en: 'The Devil Wears Prada' },
    sourceUrl: 'https://www.20thcenturystudios.com/movies/the-devil-wears-prada',
    mechanism: {
      zh: '新人为进入行业接受强势上司的规则，能力增长与自我边界产生冲突。',
      en: 'A newcomer learns a powerful boss’s rules while competence and personal boundaries pull apart.',
    },
    transform: {
      zh: '换成原创行业、组织规则与晋升条件，避免时尚杂志、助理与主编的原作组合。',
      en: 'Invent another industry, institution and promotion rules, avoiding the original magazine, assistant and editor configuration.',
    },
  },
};
